import React from 'react';
import { matchPath } from 'react-router-dom';
import PropTypes from 'prop-types';
import { List, Typography } from '@material-ui/core';
import useRouter from 'utils/useRouter';
import MenuListItem from './item';

const MenuList = props => {
  const { pages, ...rest } = props;

  return (
    <List className="p-0">
      {pages.reduce(
        (items, page) => reduceChildRoutes({ items, page, ...rest }),
        []
      )}
    </List>
  );
};

MenuList.propTypes = {
  depth: PropTypes.number,
  pages: PropTypes.array
};

const reduceChildRoutes = props => {
  const { router, items, page, depth } = props;

  if (page.content) {
    const open = matchPath(router.location.pathname, {
      path: page.to,
      exact: false
    });

    items.push(
      <MenuListItem
        depth={depth}
        hidden={page.hidden}
        icon={page.icon}
        key={page.label}
        label={page.badge}
        open={Boolean(open || page.open)}
        title={page.label}>
        <div className="sidebar-menu-children py-2">
          <MenuList
            depth={depth + 1}
            pages={page.content}
            router={router}
          />
        </div>
      </MenuListItem>
    );
  } else {
    items.push(
      <MenuListItem
        hidden={page.hidden}
        depth={depth}
        href={page.to}
        icon={page.icon}
        key={page.label}
        label={page.badge}
        title={page.label}
      />
    );
  }

  return items;
};

const MenuItems = props => {
  const { title, pages, className, component: Component, ...rest } = props;

  const router = useRouter();

  return (
    <Component {...rest} className={className}>
      {title && (
        <Typography className="app-sidebar-heading">{title}</Typography>
      )}
      <MenuList depth={0} pages={pages} router={router} />
    </Component>
  );
};

MenuItems.propTypes = {
  className: PropTypes.string,
  component: PropTypes.any,
  pages: PropTypes.array.isRequired,
  title: PropTypes.string
};

MenuItems.defaultProps = {
  component: 'nav',
  title: '',
  pages: [],
};

export default MenuItems;
